import { AfterViewChecked, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit,AfterViewChecked {
  @Input() selected:string;
  public isCollapsed = true;
  constructor(private router:Router) { }

  ngOnInit(): void {
  }

  changeNav() {
    this.router.navigate(['plans'])
  }
  changeNav1 (value) {
    if(value == 'login')this.router.navigate(['/auth/login'])
    else this.router.navigate(['/auth/signup'])
  }
  changeNavHome () {
    window.open('https://schooldapp.com/','_self')
    }

  ngAfterViewChecked(): void {
 
  }

  changeNavScholars() {
    this.router.navigate(['scholarships'])
  }
  changeNavAbout () {
    this.router.navigate(['aboutus'])
  }


}
